import moment from "moment";
import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { setResourceItemRequest } from "../../../../../controller/reducer/locationResources";
import TagDisplay from "../../../common/tags";
import "./styles.css";

function LocationItemResourceCard({ dispatch, res }) {
  return (
    <Card border="info" className="remedy-card" style={{ minWidth: "50%" }}>
      <p
        className={`h6 bg-${
          res.type === "add" ? "success" : "info"
        } text-light text-center p-1`}
      >
        {res.type === "add" ? "ADD NEW RESOURCE" : "EDIT EXISTING RESOURCE"}
      </p>
      <Card.Body>
        <Card.Title className="text-center">
          <Card.Link
            as={Link}
            to="/admin/location/editor"
            onClick={() => dispatch(setResourceItemRequest(res))}
          >
            {res.title}
          </Card.Link>
        </Card.Title>
        <Card.Text className="text-center d-flex justify-content-center">
          <Card.Link
            className="text-truncate"
            target="_blank"
            style={{ display: "table-cell" }}
            href={res.link}
          >
            {res.link}
          </Card.Link>
        </Card.Text>
        <p className="text-center">
          <TagDisplay tags={res.tags} />
        </p>
      </Card.Body>
      <Card.Footer className="text-muted">
        {res.location}, Updated {moment(res.updated).fromNow(true)} ago
      </Card.Footer>
    </Card>
  );
}

LocationItemResourceCard.defaultProps = {};

export default LocationItemResourceCard;
